var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Panel from "./Panel";
export var Collapse = function (props) {
    var _a, _b;
    var _c = props.open, open = _c === void 0 ? false : _c, children = props.children, header = props.header, _d = props.expandIconPosition, expandIconPosition = _d === void 0 ? "left" : _d, onClickOpen = props.onClickOpen, _e = props.headerClassName, headerClassName = _e === void 0 ? "" : _e, _f = props.className, className = _f === void 0 ? "" : _f, expandIcon = props.expandIcon;
    var classNames = classnames((_a = {},
        _a["mex-collapse__wrapper"] = true,
        _a[className] = className,
        _a));
    var headerClassNames = classnames((_b = {},
        _b["mex-collapse__header"] = true,
        _b[headerClassName] = headerClassName,
        _b));
    return (_jsx(React.Fragment, { children: _jsx("div", __assign({ className: classNames }, { children: header ? (_jsx(Panel, __assign({ className: classNames, header: header, open: open, expandIconPosition: expandIconPosition, headerClassName: headerClassNames, onClickOpen: onClickOpen, expandIcon: expandIcon }, { children: children }))) : (children) })) }));
};
Collapse.propTypes = {
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    open: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    expandIconPosition: PropTypes.oneOf(["left", "right"]),
    onClickOpen: PropTypes.func,
    className: PropTypes.string,
    headerClassName: PropTypes.string,
    expandIcon: PropTypes.func,
};
Collapse.defaultProps = {
    expandIconPosition: "left",
};
Collapse.Panel = Panel;
export default Collapse;
